import { PlannedMealCalendar } from "@corpuscomplete/core-ui/nutrition/planned-meal/calendar";
import { PlannedMealsCalendarPage } from "@corpuscomplete/web/modules/nutrition/planned-meal/pages/planned-meals-calendar";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/spaces/$spaceId/planned-meals/$date")({
  params: {
    parse: ({ spaceId, date }) => ({ spaceId, date: Temporal.PlainDate.from(date) }),
    stringify: ({ spaceId, date }) => ({ spaceId, date: date.toString() }),
  },
  loader: async ({ context: { zero }, params }) => {
    if (!zero) return;
    PlannedMealCalendar.preload(zero, {
      scopeId: params.spaceId,
      focusedDate: params.date,
      timeZone: Temporal.Now.timeZoneId(),
    });
  },
  onError: ({ params }) => {
    throw redirect({
      to: "/spaces/$spaceId/planned-meals/$date",
      params: { spaceId: params.spaceId, date: Temporal.Now.plainDateISO() },
    });
  },
  component: () => {
    const { spaceId, date } = Route.useParams();
    return <PlannedMealsCalendarPage focusedDate={date} scope={{ kind: "space", spaceId }} />;
  },
});
